module.exports = __webpack_public_path__ + "static/media/iconCloseModalGrey.d4b26259.svg";